import rhinoHttp from 'rhino/src/core/http/http.module';

import * as rnRecordFactory from './record.factory';
import * as rnRecordCollectionFactory from './recordCollection.factory';

export default angular.module('rhino.core.record', [
  rhinoHttp,
])
  .factory(rnRecordFactory.name, rnRecordFactory.default)
  .factory(rnRecordCollectionFactory.name, rnRecordCollectionFactory.default)
  .name;



